import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import theme from "@irati/ui/src/global/theme"

import {LandingStepperSegment} from "./styled"

interface Props {
  arrayLength?: number
  selected: number
}

const LandingStepper: FC<Props> = ({arrayLength = 3, selected}) => {
  const arr = Array(arrayLength).fill(null)

  return (
    <Flex justifyContent="center" marginBottom={4} gap={theme.spacing.half}>
      {arr.map((_, index) => (
        <LandingStepperSegment
          key={`landingStepper-${index + 1}`}
          selected={selected === index + 1}
          isFirst={index === 0}
          isLast={index === arr.length - 1}
        />
      ))}
    </Flex>
  )
}

export default LandingStepper
